/* -------------------------------------------------------
   RABATTBANNER — visas på produktsidan för blockerade kunder
------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  const promoCode = localStorage.getItem("ivita_promo_code");
  const promoPct  = parseInt(localStorage.getItem("ivita_promo_pct") || "0");

  if (!promoCode || !promoPct) return;
  if (!window.location.pathname.includes("ivitapure-testo")) return;

  fetch("/products/ivitapure-testo.js")
    .then(r => r.json())
    .then(function (product) {
      const originalPrice    = product.price / 100;
      const discountedPrice  = Math.round(originalPrice * (1 - promoPct / 100));

      const banner = document.createElement("div");
      banner.className = "ivita-discount-banner";
      banner.innerHTML =
        "<span class='ivita-discount-banner__icon'>✅</span>" +
        "<span class='ivita-discount-banner__text'>" +
          "Din rabattkod <strong>" + promoCode + "</strong> är aktiverad &mdash; " +
          "du betalar <strong>" + discountedPrice + " kr</strong> " +
          "<s style='opacity:.6;font-weight:400;'>" + originalPrice + " kr</s>" +
        "</span>";

      /* Sätt in bannern precis ovanför priset */
      const priceEl = document.querySelector(".price__container") ||
                      document.querySelector("[class*='price']");
      if (priceEl) {
        priceEl.parentNode.insertBefore(banner, priceEl);
      } else {
        document.querySelector("main")?.prepend(banner);
      }
    })
    .catch(function () { /* tyst fel — ingen banner */ });
});
// Rensa rabattflagga efter genomfört köp
if (window.location.pathname.includes('/thank_you') || 
    window.location.pathname.includes('/orders/')) {
  localStorage.removeItem('ivita_promo_code');
  localStorage.removeItem('ivita_promo_pct');
}